export default __webpack_public_path__ + "static/media/earth.091d6e95.png";